import { render, staticRenderFns } from "./RouteLink.vue?vue&type=template&id=8bbc9fcc&"
import script from "./RouteLink.vue?vue&type=script&lang=js&"
export * from "./RouteLink.vue?vue&type=script&lang=js&"
import style0 from "./RouteLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports